module.exports = __webpack_public_path__ + "static/media/dumbbell.6fb7e606.svg";